import {
  getTokenStr,
  login,
  logout,
  getInfo,
  getUserSubIdentities,
  getUserInfo,
  getUserRoleMenus
} from '@/api/user'
import {
  getStorage,
  setStorage,
  removeStorage
} from '@/utils/storage'
import {
  getToken,
  setToken,
  removeToken,
  setAccessToken,
  setAccessTokenExpiredTime,
  setIntroduction,
  setCustomBase64,
  setMenuIdList,
  removeMenuIdList,
  removeCustomBase64,
  removeIntroduction,
  removeAccessToken,
  removeAccessTokenExpiredTime,
  getIntroduction,
  getMerchantInfo,
  removeBtnCodeAuth,
  removeIdentityIndex,
  removeCurrnetMerchant,
  getCurrnetMerchant,
  removeCurrentMerchantIndex,
  getCurrentHotel,
  getCustomBase64,
  removeCurrentHotelId,
  removeCurrentHotel
} from '@/utils/auth'
import router, {
  resetRouter
} from '@/router'
import {
  reject
} from 'lodash'

const state = {
  token: getToken(),
  access_token: '',
  access_token_expired_time: '',
  name: '',
  avatar: '',
  introduction: '',
  custombase64: '',
  roles: [],
  menuAuthList: [],
  btnAuthList: [],
  menuAuthIdList: [],
  btnAuthIdList: [],
  menuIdList: [],
  subIdentities: [],
  isLock: getStorage({
    name: 'isLock'
  }) || false,
  lockPasswd: getStorage({
    name: 'lockPasswd'
  }) || '',
  lockUrl: getStorage({
    name: 'lockUrl'
  }) || '/dashboard'
}

const mutations = {
  SET_ACCESS_TOKEN: (state, access_token) => {
    console.log('state', state, 'access_token', access_token)
    state.access_token = access_token
  },
  SET_ACCESS_TOKEN_EXPIRED_TIME: (state, time) => {
    state.access_token_expired_time = time
  },
  SET_TOKEN: (state, token) => {
    console.log('state', state, 'token', token)
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_CUSTOMBASE64: (state, custombase64) => {
    state.custombase64 = custombase64
  },
  SET_MENUAUTH: (state, menuAuthList) => {
    state.menuAuthList = menuAuthList
  },
  SET_BTNAUTH: (state, btnAuthList) => {
    state.btnAuthList = btnAuthList
  },
  SET_MENUAUTHIDLIST: (state, menuAuthIdList) => {
    state.menuAuthIdList = menuAuthIdList
  },
  SET_MENUAUTHIDLISTROOT: (state) => {
    state.menuAuthIdList = [{
      isRoot: true
    }]
  },
  SET_BTNAUTHIDLIST: (state, btnAuthIdList) => {
    state.btnAuthIdList = btnAuthIdList
  },
  SET_MENUIDLIST: (state, menuIdList) => {
    state.menuIdList = menuIdList
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_SUBIDENTITIES: (state, subIdentities) => {
    state.subIdentities = subIdentities
  },
  SET_LOCK_PASSWD: (state, lockPasswd) => {
    state.lockPasswd = lockPasswd
    setStorage({
      name: 'lockPasswd',
      content: state.lockPasswd,
      type: 'session'
    })
  },
  SET_LOCK_URL: (state, lockUrl) => {
    state.lockUrl = lockUrl
    setStorage({
      name: 'lockUrl',
      content: state.lockUrl,
      type: 'session'
    })
  },
  SET_LOCK: (state, action) => {
    state.isLock = true
    setStorage({
      name: 'isLock',
      content: state.isLock,
      type: 'session'
    })
  },
  CLEAR_LOCK: (state, action) => {
    state.isLock = false
    state.lockPasswd = ''
    removeStorage({
      name: 'lockPasswd'
    })
    removeStorage({
      name: 'isLock'
    })
  }
}

const actions = {
  // 获取token
  getTokenStr({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getTokenStr().then(response => {
        console.log('responese', response, response.content)
        commit('SET_ACCESS_TOKEN', response.content)
        commit('SET_ACCESS_TOKEN_EXPIRED_TIME', parseInt(new Date().getTime() / 1000) + 0.1 * 60 * 60)
        // console.log(merchant.getters.state)
        setAccessToken(response.content)
        setAccessTokenExpiredTime(parseInt(new Date().getTime() / 1000) + 0.1 * 60 * 60)
        resolve()
      }).catch(error => {
        console.log('cuowuwww', error)
        reject(error)
      })
    })
  },

  // 获取roles
  getRoles({
    commit
  }) {
    return new Promise((resolve, reject) => {
      resolve()
    })
  },

  getUserRoleMenus({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      getUserRoleMenus(params.accountID).then(response => {
        if (response && response.menuIDs) {
          if (params.isAdmin) {
            response.menuIDs.push(900)
            response.menuIDs.push(901)
            response.menuIDs.push(902)
          }
          setMenuIdList(response.menuIDs)
          commit('SET_MENUIDLIST', response.menuIDs)
        }
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  clearRoles({
    commit
  }) {
    return new Promise((resolve, reject) => {
      try {
        commit('SET_ROLES', '')
        resolve('')
      } catch {
        reject('')
      }
    })
  },

  clearMenuIds({
    commit
  }) {
    return new Promise((resolve, reject) => {
      try {
        commit('SET_MENUIDLIST', '')
        resolve()
      } catch {
        reject()
      }
    })
  },
  // user login
  // login({
  //   commit
  // }, userInfo) {
  //   const {
  //     userno,
  //     password
  //   } = userInfo
  //   return new Promise((resolve, reject) => {
  //     login(userno.trim(), password.trim()).then(response => {
  //       resolve(response)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   }).then((result) => {
  //     return new Promise((resolve, reject) => {
  //       getUserInfo(result).then(response => {
  //         var userInfo = response
  //         commit('SET_INTRODUCTION', userInfo)
  //         setIntroduction(userInfo)
  //         var customBase64 = new Buffer(JSON.stringify(userInfo.accountIdentities[0])).toString('base64')

  //         commit('SET_CUSTOMBASE64', customBase64)
  //         setCustomBase64(customBase64)
  //         resolve()
  //       }).catch((error) => {
  //         reject(error)
  //       })
  //     })
  //   }).catch((error) => {
  //     reject(error)
  //   })
  // },

  login({
    commit
  }, userInfo) {
    const {
      userno,
      password
    } = userInfo
    return new Promise((resolve, reject) => {
      login(userno.trim(), password.trim()).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getUserInfo({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      getUserInfo(id).then(response => {
        var userInfo = response
        commit('SET_INTRODUCTION', userInfo)
        setIntroduction(userInfo)
        var customBase64 = new Buffer(JSON.stringify(userInfo.accountIdentities[0])).toString('base64')

        commit('SET_CUSTOMBASE64', customBase64)
        setCustomBase64(customBase64)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },

  loginbak({
    commit
  }, userInfo) {
    const {
      username,
      password
    } = userInfo
    console.log(username, '||', password)
    return new Promise((resolve, reject) => {
      login(username.trim(), password.trim()).then(response => {
        const {
          data
        } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  setRootPass({
    commit
  }) {
    return new Promise((resolve, reject) => {
      commit('SET_MENUAUTHIDLISTROOT')
      resolve()
    })
  },

  // user logout
  logout({
    commit,
    state,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      try {
        commit('SET_INTRODUCTION', '')
        commit('SET_CUSTOMBASE64', '')
        commit('SET_ACCESS_TOKEN', '')
        commit('SET_ACCESS_TOKEN_EXPIRED_TIME', '')
        commit('SET_MENUAUTH', [])
        commit('SET_BTNAUTH', [])
        commit('SET_MENUAUTHIDLIST', [])
        commit('SET_BTNAUTHIDLIST', [])
        commit('SET_SUBIDENTITIES', [])
        commit('SET_ROLES', '')

        commit('SET_MENUIDLIST', '')
        // removeMenuAuthIdList()
        removeCustomBase64()
        removeCurrnetMerchant()
        removeIntroduction()
        removeAccessToken()
        removeAccessTokenExpiredTime()
        localStorage.removeItem('subIdentities')
        // removeSubIdentities()
        removeBtnCodeAuth()
        removeIdentityIndex()
        removeCurrentMerchantIndex()
        removeMenuIdList()
        removeCurrentHotelId()
        removeCurrentHotel()
        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {
          root: true
        })
        resolve()
      } catch (e) {
        reject('退出失败')
      }
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({
    commit,
    dispatch
  }, role) {
    const token = role + '-token'
    commit('SET_TOKEN', token)
    setToken(token)

    const {
      roles
    } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, {
      root: true
    })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, {
      root: true
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
